/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import { HubBootstrapWrapperQuery, mockHubRouteProps } from '@atlassian/company-hub-common';
import { HUB_PREVIEW_ROUTE_NAME } from '../../controllers/constants';
import HubQuery from '../../ui/hub/__generated__/hubQuery.graphql';
import { createRelayResource, getPageAri } from './utils';
export var hubBootstrapResource = createRelayResource({
  getQuery: function getQuery(_ref, _ref2) {
    var match = _ref.match,
      route = _ref.route;
    var cloudId = _ref2.cloudId,
      helpCenterAri = _ref2.helpCenterAri;
    var isPreview = (route === null || route === void 0 ? void 0 : route.name) === HUB_PREVIEW_ROUTE_NAME;
    var pageId = match.params.id || '';
    var cloudIdDerived = cloudId;
    var helpCenterAriDerived = helpCenterAri;
    if (isPreview && mockHubRouteProps.env.cloudId && mockHubRouteProps.env.helpCenterAri) {
      cloudIdDerived = mockHubRouteProps.env.cloudId;
      helpCenterAriDerived = mockHubRouteProps.env.helpCenterAri;
    }
    return {
      variables: {
        cloudId: cloudIdDerived,
        hubAri: helpCenterAriDerived,
        pageAri: getPageAri(helpCenterAriDerived, pageId),
        operationType: 'READ',
        hubEditMode: false
      },
      query: HubBootstrapWrapperQuery,
      options: {
        fetchPolicy: 'store-or-network'
      }
    };
  }
});
export var hubPageResource = createRelayResource({
  getQuery: function getQuery(_ref3, _ref4) {
    var match = _ref3.match,
      route = _ref3.route;
    var cloudId = _ref4.cloudId,
      helpCenterAri = _ref4.helpCenterAri;
    var isPreview = (route === null || route === void 0 ? void 0 : route.name) === HUB_PREVIEW_ROUTE_NAME;
    var pageId = match.params.id || '';
    var cloudIdDerived = cloudId;
    var helpCenterAriDerived = helpCenterAri;
    if (isPreview && mockHubRouteProps.env.cloudId && mockHubRouteProps.env.helpCenterAri) {
      cloudIdDerived = mockHubRouteProps.env.cloudId;
      helpCenterAriDerived = mockHubRouteProps.env.helpCenterAri;
    }
    return {
      variables: {
        cloudId: cloudIdDerived,
        hubAri: helpCenterAriDerived,
        pageAri: getPageAri(helpCenterAriDerived, pageId)
      },
      query: HubQuery,
      options: {
        fetchPolicy: 'store-or-network'
      }
    };
  }
});